webpackJsonp([217837931937914],{

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AddContent = function AddContent() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'field-name-body' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'add-story-title' },
	      'Add your story!'
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We invite you to add to the conversation by sending us your story and a picture. To do so, email us at papershoepress@gmail.com. We will review your story and get it up on the site as soon as possible!'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      'Remember to include the following in your message:',
	      _react2.default.createElement(
	        'li',
	        null,
	        'an intriguing title ... '
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'the year it takes place '
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'your name '
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'your message or story! '
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'and a picture! '
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'We look forward to hearing from you soon!'
	    )
	  );
	};
	
	exports.default = AddContent;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-add-content-js-38f4c8ed715bd4664389.js